import styled from 'styled-components';

export const MetricWrapper = styled('div')`
  position: relative;
  margin: ${({ theme }) =>
    `${theme.x2spacePx}px ${theme.x2spacePx}px ${theme.x1spacePx}px`};

  &:nth-child(2) {
    ${({ theme }) => `margin-top: ${theme.x1spacePx}px`}
  }
  height: min-content;
  &:before {
    content: '';
    display: block;
    position: absolute;
    width: ${({ theme }) => theme.x1spacePx / 2}px;
    height: 100%;
    top: 0;
    background: ${({ theme }) => theme.color.brand01};
    border-radius: 4px;
    margin-left: -${({ theme }) => theme.x2spacePx}px;
  }

  p {
    &:nth-child(2) {
      white-space: nowrap;
    }
  }
`;
